import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ResgatePacoteJanelaComponent } from './resgate-pacote-janela.component';

@NgModule({
  imports: [RouterModule.forChild([
    {path: ':id', component: ResgatePacoteJanelaComponent}
  ])],
  exports: [RouterModule]
})
export class ResgatePacoteJanelaRoutingModule { }
